export default {
  status: {
    open: "Open",
    in_progress: "In Progress",
    waiting_response: "Awaiting Reply",
    resolved: "Resolved",
    closed: "Closed",
  },
  priority: {
    "1": "Critical",
    "2": "High",
    "3": "Medium",
    "4": "Low",
    "5": "Trivial",
  },
  category: {
    problem: "Problem",
    suggestion: "Suggestion",
    improvement: "Improvement",
    question: "Question",
    billing: "Billing",
  },
} as const;
